module.exports = __webpack_public_path__ + "img/mustard.8f575597.svg";